export default `
.dte-preview {
  --dte-ui-blue: #1976d2;
  --dte-ui-blue-dark: #1565c0;
  --dte-ui-blue-soft: #e3f2fd;
  --dte-brand: #0f4c81;
  --dte-brand-contrast: #ffffff;
  --dte-accent: #d9a441;
  --dte-surface: #f5f8fc;
  --dte-border: #c7d5e5;
  --dte-table-border: #c7d5e5;
  --dte-card-radius: 14px;
  --dte-table-radius: 0px;
  --dte-text: #1b2a3a;
  --dte-muted: #6c7b8a;
  --dte-card-header-gradient-strong: rgba(15, 76, 129, 0.1);
  --dte-card-header-gradient-soft: rgba(15, 76, 129, 0.01);
  --dte-title-font-size: 18px;
  --dte-text-font-size: 12px;
  --dte-detail-font-size: 11px;
  min-height: 100vh;
  padding: 24px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at top right, rgba(15, 76, 129, 0.22), transparent 22%),
    linear-gradient(180deg, #e9eff8 0%, #d7e0ec 100%);
  color: var(--dte-text);
  font-family: "Trebuchet MS", "Segoe UI", sans-serif;
}

.dte-preview *,
.dte-sheet,
.dte-sheet * {
  box-sizing: border-box;
}

.dte-preview__toolbar {
  position: relative;
  top: auto;
  z-index: 12;
  display: grid;
  grid-template-columns: minmax(280px, 4fr) minmax(0, 8fr);
  grid-template-areas:
    "heading layout"
    "heading controls";
  align-items: start;
  gap: 12px 20px;
  margin: 0 auto 24px;
  padding: 18px 20px;
  max-width: 1080px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 22px;
  backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 18px 40px rgba(27, 42, 58, 0.12);
}

.dte-preview__heading {
  grid-area: heading;
  min-width: 0;
  align-self: center;
}

.dte-preview__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
}

.dte-preview__subtitle {
  margin: 6px 0 0;
  color: var(--dte-muted);
  font-size: 0.92rem;
}

.dte-preview__controls,
.dte-preview__layout-picker {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.dte-preview__layout-picker {
  grid-area: layout;
  min-width: 0;
  justify-content: flex-end;
  align-content: flex-start;
}

.dte-preview__controls {
  grid-area: controls;
  min-width: 0;
  justify-content: flex-end;
  align-content: flex-start;
}

.dte-preview__layout-label {
  width: 100%;
  text-align: right;
  color: var(--dte-muted);
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.dte-button {
  appearance: none;
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.dte-button:hover {
  transform: translateY(-1px);
}

.dte-button:disabled {
  opacity: 0.65;
  cursor: wait;
  transform: none;
}

.dte-button--primary {
  background: var(--dte-ui-blue);
  color: #ffffff;
  box-shadow: 0 10px 22px rgba(25, 118, 210, 0.24);
}

.dte-button--secondary {
  border-color: var(--dte-ui-blue);
  background: #ffffff;
  color: var(--dte-ui-blue-dark);
}

.dte-button--accent {
  background: var(--dte-ui-blue);
  color: #ffffff;
}

.dte-button--ghost {
  border-color: rgba(25, 118, 210, 0.28);
  background: var(--dte-ui-blue-soft);
  color: var(--dte-ui-blue-dark);
}

.dte-button--toggle.is-active {
  background: var(--dte-ui-blue);
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(25, 118, 210, 0.2);
}

.dte-preview__status {
  max-width: 1080px;
  margin: 0 auto 20px;
  text-align: center;
  color: var(--dte-muted);
  font-weight: 700;
}

.dte-preview__pages {
  display: grid;
  gap: 32px;
  justify-content: center;
}

.dte-preview__pages > div {
  display: grid;
  gap: 32px;
  justify-items: center;
}

.dte-preview__pages .dte-sheet {
  outline: 1px solid rgba(27, 42, 58, 0.08);
}

.dte-preview__canvas {
  position: relative;
  min-height: 11in;
}

.dte-preview__loading {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: rgba(245, 248, 252, 0.82);
  backdrop-filter: blur(4px);
}

.dte-preview__spinner {
  width: 54px;
  height: 54px;
  border: 4px solid rgba(25, 118, 210, 0.16);
  border-top-color: var(--dte-ui-blue);
  border-radius: 50%;
  animation: dte-spin 0.9s linear infinite;
}

.dte-preview__loading-label {
  color: var(--dte-text);
  font-weight: 700;
  letter-spacing: 0.01em;
}

@keyframes dte-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.dte-sheet {
  position: relative;
  width: 8.5in;
  min-width: 8.5in;
  max-width: 8.5in;
  min-height: 11in;
  height: 11in;
  max-height: 11in;
  padding: 0.38in;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 22px 50px rgba(27, 42, 58, 0.16);
  color: var(--dte-text);
  overflow: hidden;
  page-break-after: always;
  break-after: page;
}

.dte-sheet--banner-full {
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.dte-sheet:last-child {
  page-break-after: auto;
  break-after: auto;
}

.branch-dte-preview__pages {
  gap: 32px;
}

.dte-sheet__page-number {
  position: absolute;
  right: 0.45in;
  bottom: 0.22in;
  color: var(--dte-muted);
  font-size: calc(var(--dte-text-font-size) - 2px);
}

.dte-banner {
  margin-bottom: 12px;
  padding: 10px 14px;
  border-radius: 14px;
  font-size: 0.88rem;
  font-weight: 700;
}

.dte-banner--danger {
  background: #fbe1e1;
  color: #9b1c1c;
  border: 1px solid #f0b0b0;
}

.dte-card {
  border: 1px solid var(--dte-table-border);
  border-radius: var(--dte-card-radius);
  background: #ffffff;
  overflow: hidden;
}

.dte-card__header {
  padding: 8px 12px;
  background: var(--dte-brand);
  border-bottom: 1px solid var(--dte-table-border);
  font-size: calc(var(--dte-title-font-size) - 6px);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--dte-brand-contrast);
}

.dte-card__header--centered {
  text-align: center;
}

.dte-card__header--document-title {
  padding: 8px 12px;
  font-size: calc(var(--dte-title-font-size) - 3px);
  font-weight: 800;
  letter-spacing: 0.03em;
  line-height: 1.15;
}

.dte-card__body {
  padding: 11px;
}

.dte-business-card {
  padding: 9px 10px;
}

.dte-business-card__columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 108px;
  gap: 14px;
  align-items: start;
}

.dte-business-card__main {
  min-width: 0;
}

.dte-business-card__media {
  display: grid;
  gap: 6px;
  min-width: 220px;
  max-width: 330px;
  align-content: start;
}

.dte-business-card__media--row {
  display: flex;
  align-items: flex-start;
  min-width: 100%;
  max-width: 100%;
  margin-bottom: 8px;
  justify-content: flex-start;
}

.dte-business-card__qr {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: center;
  margin-left: auto;
}

.dte-business-card__qr-column {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.dte-business-card__info {
  min-width: 0;
  flex: 1;
  gap: 5px;
}

.dte-grid {
  display: grid;
  gap: 10px;
}

.dte-grid--2 {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.dte-recipient-grid {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
}

.dte-definition-list {
  display: grid;
  gap: 5px;
}

.dte-definition-list__row {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  font-size: var(--dte-text-font-size);
  line-height: 1.18;
}

.dte-definition-list__row dt {
  font-weight: 700;
}

.dte-definition-list__row dd {
  margin: 0;
  word-break: break-word;
}

.dte-definition-list__row--single {
  grid-template-columns: minmax(0, 1fr) !important;
}

.dte-logo {
  display: block;
  width: auto;
  max-width: 280px;
  height: auto;
  max-height: 84px;
  object-fit: contain;
}

.dte-banner-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  max-height: 220px;
}

.dte-banner-card {
  border: none;
  box-shadow: none;
  background: transparent;
  overflow: hidden;
  width: 100%;
  margin-top: 8px;
}

.dte-full-page-banner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #ffffff;
}

.dte-full-page-banner__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  background: #ffffff;
}

.dte-metadata {
  display: grid;
  gap: 3px;
}

.dte-document-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.dte-document-card__info {
  min-width: 0;
  flex: 1;
}

.dte-document-card__qr {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  min-width: 88px;
}

.dte-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.dte-chip {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 10px;
  background: var(--dte-surface);
  border: 1px solid var(--dte-border);
  color: var(--dte-text);
  font-size: calc(var(--dte-text-font-size) - 1px);
  font-weight: 700;
}

.dte-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--dte-table-border);
  border-radius: var(--dte-table-radius);
  overflow: hidden;
}

.dte-table thead {
  display: table-header-group;
}

.dte-table tr,
.dte-table td,
.dte-table th {
  page-break-inside: avoid;
  break-inside: avoid;
}

.dte-table th,
.dte-table td {
  padding: 6px 8px;
  border-bottom: 1px solid var(--dte-table-border);
  vertical-align: top;
  font-size: calc(var(--dte-text-font-size) - 1px);
  line-height: 1.16;
}

.dte-table thead th {
  background: var(--dte-brand);
  color: var(--dte-brand-contrast);
  font-size: calc(var(--dte-title-font-size) - 7px);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.dte-table tbody tr:nth-child(even) td {
  background: rgba(245, 248, 252, 0.65);
}

.dte-table__right {
  text-align: right;
  white-space: nowrap;
}

.dte-table__center {
  text-align: center;
}

.dte-table__description {
  white-space: pre-line;
  word-break: break-word;
}

.dte-table--detail th,
.dte-table--detail td {
  padding: 4px 6px;
  font-size: var(--dte-detail-font-size);
  line-height: 1.12;
}

.dte-table--detail thead th {
  font-size: calc(var(--dte-detail-font-size) - 1px);
  letter-spacing: 0.04em;
}

.dte-table--detail .dte-table__description {
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.dte-summary {
  display: grid;
  gap: 10px;
}

.dte-qr-card {
  display: grid;
  justify-items: center;
  gap: 10px;
  text-align: center;
}

.dte-qr-card__text {
  margin: 0;
  font-size: calc(var(--dte-text-font-size) - 1px);
  line-height: 1.2;
  color: var(--dte-muted);
}

.dte-summary__stack {
  display: grid;
  gap: 6px;
}

.dte-total-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  font-size: var(--dte-text-font-size);
  line-height: 1.18;
  padding-bottom: 6px;
  border-bottom: 1px dashed var(--dte-border);
}

.dte-total-row.is-emphasis {
  font-weight: 800;
  color: var(--dte-brand);
}

.dte-qrcode {
  width: 92px;
  height: 92px;
  object-fit: contain;
  border: 1px solid var(--dte-table-border);
  border-radius: var(--dte-card-radius);
  background: #ffffff;
  padding: 5px;
}

.dte-qrcode--inline {
  width: 88px;
  height: 88px;
  padding: 4px;
}

.dte-qrcode--emitter {
  width: 96px;
  height: 96px;
  padding: 4px;
}

.dte-qrcode--placeholder {
  border-style: dashed;
  border-color: rgba(47, 93, 140, 0.35);
  background: rgba(47, 93, 140, 0.04);
}

.dte-qrcode--plain {
  border: none;
  background: transparent;
  padding: 0;
}

.dte-footer-note {
  margin: 0;
  white-space: pre-line;
  line-height: 1.28;
  font-size: calc(var(--dte-text-font-size) - 1px);
}

.dte-footer-card,
.dte-footer-card__notes,
.dte-footer-note {
  page-break-inside: avoid;
  break-inside: avoid;
}

.dte-footer-contacts {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 10px;
}

.dte-footer-contacts__card {
  padding: 10px;
  border: 1px solid var(--dte-table-border);
  border-radius: var(--dte-card-radius);
  background: var(--dte-surface);
}

.dte-muted {
  color: var(--dte-muted);
}

.dte-section-title {
  margin: 0 0 10px;
  font-size: var(--dte-text-font-size);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--dte-brand);
}

.dte-spacer {
  height: 8px;
}

@media print {
  @page {
    size: letter portrait;
    margin: 0;
  }

  .dte-preview {
    padding: 0;
    background: #ffffff;
  }

  .dte-preview__toolbar,
  .dte-preview__status {
    display: none !important;
  }

  .dte-preview__pages {
    display: block;
  }

  .dte-preview__pages > div {
    display: block;
  }

  .dte-sheet {
    margin: 0 !important;
    outline: none;
    border-radius: 0;
    box-shadow: none;
  }
}

@media (max-width: 980px) {
  .dte-preview__toolbar {
    grid-template-columns: minmax(220px, 4fr) minmax(0, 8fr);
    padding: 16px;
  }

  .dte-preview__heading,
  .dte-preview__layout-picker,
  .dte-preview__controls {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .dte-preview__toolbar {
    position: static;
    top: auto;
    grid-template-columns: 1fr;
    grid-template-areas:
      "heading"
      "layout"
      "controls";
    gap: 10px 14px;
    margin-bottom: 16px;
    padding: 14px;
    border-radius: 18px;
    backdrop-filter: none;
  }

  .dte-preview__heading,
  .dte-preview__layout-picker,
  .dte-preview__controls {
    width: 100%;
  }

  .dte-preview__loading {
    position: absolute;
    border-radius: 18px;
  }

  .dte-preview__layout-picker,
  .dte-preview__controls {
    justify-content: flex-start;
  }

  .dte-preview__layout-label {
    text-align: left;
  }

  .dte-button {
    flex: 0 0 auto;
    text-align: center;
  }
}

@media (max-width: 520px) {
  .dte-preview__toolbar {
    gap: 8px 10px;
    padding: 12px;
  }

  .dte-preview__title {
    font-size: 1.12rem;
  }

  .dte-preview__subtitle {
    font-size: 0.84rem;
  }

  .dte-preview__layout-picker,
  .dte-preview__controls {
    gap: 6px;
  }

  .dte-button {
    padding: 9px 12px;
    font-size: 0.84rem;
  }
}

@media print {
  .dte-sheet {
    width: 8.5in !important;
    min-width: 8.5in !important;
    max-width: 8.5in !important;
    height: 11in !important;
    min-height: 11in !important;
    max-height: 11in !important;
    overflow: hidden !important;
  }

  .dte-sheet--full {
    padding: 0.38in !important;
  }

  .dte-sheet--standard {
    padding: 0.28in 0.42in 0.34in !important;
  }

  .dte-sheet--compact {
    padding: 0.24in !important;
  }

  .dte-grid--2,
  .dte-footer-contacts,
  .dte-recipient-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }

  .dte-definition-list__row {
    grid-template-columns: 150px minmax(0, 1fr) !important;
  }

  .dte-sheet--compact .dte-definition-list__row {
    grid-template-columns: 120px minmax(0, 1fr) !important;
  }

  .dte-sheet--full .dte-business-card__info .dte-definition-list__row {
    grid-template-columns: 108px minmax(0, 1fr) !important;
  }

  .dte-sheet--full .dte-header-layout__meta .dte-definition-list__row {
    grid-template-columns: 112px minmax(0, 1fr) !important;
  }

  .dte-sheet--compact .dte-header-layout__meta .dte-definition-list__row {
    grid-template-columns: 58px minmax(0, 1fr) !important;
  }
}
`;
